import { useVariation } from '@hooks/useVariation';
import cx from '@utils/cx.util';
import warrantyIcon from '@features/pdp/images/icons/icon-warranty.svg';

const ProductWarranty = ({ warrantyPeriod, className = '' }) => {
  const isEnhancedPDPVariant = useVariation('Enhanced PDP');

  const warrantyYears = getWarrantyYears(warrantyPeriod);

  if (!warrantyPeriod || warrantyYears < 1 || !isEnhancedPDPVariant) return null;

  return (
    <div
      className={cx(
        'tw:flex tw:w-full tw:gap-[6px]',
        {
          'tw:items-center tw:rounded-button tw:border tw:border-neutrals-light-grey tw:p-2':
            isEnhancedPDPVariant,
        },
        className
      )}>
      <div className='tw:flex tw:size-6 tw:shrink-0 tw:items-center tw:justify-center'>
        <img src={warrantyIcon} alt='warranty' className='tw:max-h-full tw:w-full tw:max-w-full' />
      </div>
      <div className='tw:flex tw:flex-col'>
        <p className='tw:mb-0 tw:text-sm tw:font-medium tw:leading-none tw:text-brand-black'>
          {warrantyYears} Year Warranty
        </p>
      </div>
    </div>
  );
};

export default ProductWarranty;

const getWarrantyYears = (warrantyPeriod) => {
  if (!warrantyPeriod) return null;
  const match = warrantyPeriod.match(/(\d+)\s*year/i);
  return match ? parseInt(match[1], 10) : null;
};
